import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useContext, useReducer } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { getChats, createChat } from '../api';
import generateChatName from '../helpers/generateChatName';
import loadLocalStorageSettings from '../helpers/loadLocalStorageSettings';
import saveLocalStorageSettings from '../helpers/saveLocalStorageSettings';
import ApiContext from '../contexts/apiContext';
import ChatContext from '../contexts/chatContext';
import chatsReducer from '../reducers/chatsReducer';
import Chat from './Chat';
import MainMenu from './MainMenu';
import ErrorDialog from './ErrorDialog';
var ChatUI = function () {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useReducer(chatsReducer, {}), _c = _b[0], chats = _c.chats, selectedChatId = _c.selectedChatId, dispatch = _b[1];
    var _d = useState(), errorMessage = _d[0], setErrorMessage = _d[1];
    var apiBaseUrl = useContext(ApiContext).apiBaseUrl;
    useEffect(function () {
        setLoading(true);
        getChats(apiBaseUrl)
            .then(function (fetchedChats) {
            var _a;
            var localStorageSettings = loadLocalStorageSettings();
            var savedSelectedChatId = localStorageSettings === null || localStorageSettings === void 0 ? void 0 : localStorageSettings.selectedChatId;
            var chatId = savedSelectedChatId && fetchedChats.find(function (_a) {
                var id = _a.id;
                return id === savedSelectedChatId;
            })
                ? savedSelectedChatId
                : (_a = fetchedChats[0]) === null || _a === void 0 ? void 0 : _a.id;
            dispatch({
                state: {
                    chats: fetchedChats,
                    selectedChatId: chatId
                },
                type: 'populate_chats'
            });
        })
            .catch(function (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            setErrorMessage("There's been an error fetching chats, please check your connection and reload the page");
        })
            .finally(function () { return setLoading(false); });
    }, [dispatch]);
    useEffect(function () {
        if (chats && chats.length === 0) {
            setLoading(true);
            createChat(apiBaseUrl, generateChatName(chats))
                .then(function (newChat) {
                return dispatch({
                    state: {
                        newChat: newChat
                    },
                    type: 'add_chat'
                });
            })
                .catch(function (err) {
                // eslint-disable-next-line no-console
                console.error(err);
                setErrorMessage("There's been an error creating a new chat, please check your connection and reload the page");
            })
                .finally(function () { return setLoading(false); });
        }
    }, [chats, dispatch]);
    useEffect(function () {
        if (selectedChatId) {
            saveLocalStorageSettings({ selectedChatId: selectedChatId });
        }
    }, [selectedChatId]);
    var handleErrorDialogClose = function () { return setErrorMessage(undefined); };
    var chat = selectedChatId ? chats === null || chats === void 0 ? void 0 : chats.find(function (_a) {
        var id = _a.id;
        return id === selectedChatId;
    }) : undefined;
    return (_jsxs(Box, { height: "100%", children: [_jsx(ErrorDialog, { message: errorMessage, onClose: handleErrorDialogClose }), loading && (_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: "100vh", children: _jsx(CircularProgress, {}) })), _jsxs(ChatContext.Provider, { value: { chat: chat, dispatch: dispatch }, children: [!loading && chats && _jsx(MainMenu, { chats: chats, dispatch: dispatch }), _jsx(Box, { height: "100%", children: selectedChatId && _jsx(Chat, {}, selectedChatId) })] })] }));
};
export default ChatUI;
